import { render, staticRenderFns } from "./EvidenceSubmissionUserStatus.vue?vue&type=template&id=f0ebdef8&scoped=true&"
import script from "./EvidenceSubmissionUserStatus.vue?vue&type=script&lang=js&"
export * from "./EvidenceSubmissionUserStatus.vue?vue&type=script&lang=js&"
import style0 from "./EvidenceSubmissionUserStatus.vue?vue&type=style&index=0&id=f0ebdef8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ebdef8",
  null
  
)

export default component.exports